/**
 * Environment Detection Utilities
 * 
 * CRITICAL: These checks determine security-sensitive bypasses (e.g., subscription gates).
 * They MUST fail closed - if there's ANY ambiguity, assume production.
 */

/**
 * Detects if running against Firebase Emulators
 * 
 * Checks (in order):
 * 1. Auth emulator connection (most reliable)
 * 2. Localhost in DEV mode
 * 
 * @returns true ONLY if definitively running against emulators
 */
export function isEmulator(): boolean {
  // Check 1: Auth emulator connected?
  // This is set when connectAuthEmulator() is called in firebase.js
  if (typeof window !== 'undefined' && (window as any).__FIREBASE_EMULATOR_HOST__) {
    return true;
  }

  // Check 2: Localhost in DEV mode (simple and reliable)
  if (typeof window !== 'undefined' && import.meta.env.DEV) {
    const isLocalhost = window.location.hostname === 'localhost' || 
                       window.location.hostname === '127.0.0.1';

    if (isLocalhost) {
      return true;
    }
  }

  // Default: Fail closed - assume production
  return false;
}

/**
 * Detects if running in Cypress test environment
 * 
 * @returns true if Cypress is detected
 */
export function isCypress(): boolean {
  return typeof window !== 'undefined' && !!(window as any).Cypress;
}

/**
 * Combined check for audit/test environment
 * 
 * Use this for audit-specific bypasses that should ONLY work in
 * emulator + Cypress environment.
 * 
 * @returns true ONLY if emulator AND Cypress
 */
export function isAuditEnvironment(): boolean {
  return isEmulator() && isCypress();
}
